import { bridge, loader, native, os, webviewInfo, util } from '@ali/amap-lib';
import CONFIG_AOS from '../../config/config.aos';
// import CONFIG_ACT from '../../config/config.act';
// const activity = CONFIG_ACT.activity;
const asac = util.getUrlParam('asac') || "2A20402V011135EFX42JI2";
const myLoader = (() => {
  const requestHandler = loader;

  return (method = 'get', url, params) => {
    const isInAmap = webviewInfo.isInAmap();

    if (!url) {
      return Promise.reject(new Error('请求地址不存在.'));
    }

    return new Promise((resolve, reject) => {
      let handler = requestHandler.aosJsonp;

      if (isInAmap) {
        handler = requestHandler[method];
        method = () => {};
      }
      handler(
        url,
        params,
        (response) => {
          console.log('[AOS请求] ', url, params);
          console.log('[AOS响应] ', response);
          if (
            response &&
            response.code &&
            parseInt(response.code.toString(), 10) === 1
          ) {
            const { timestamp } = response;

            // 派发时间
            if (timestamp && CustomEvent) {
              const myEvent = new CustomEvent('serverTimeUpdate', {
                detail: {
                  timestamp: parseInt(timestamp),
                },
              });

              window.dispatchEvent(myEvent);
            }
            resolve(response.data || response.code);
          } else {
            reject(response);
          }
        },
        method,
        false,
        true, // WUA
        { asac } //asac
      );
    });
  };
})();

const sign = 1;

export default {
  /*
   * 用户访问浏览器环境
   */
  browserEnvironment() {
    var ua = navigator.userAgent.toLowerCase();
    if(ua.match(/MicroMessenger/i) == 'micromessenger' && ua.indexOf('miniprogram') != -1){
      return 'weixinmini'
    }else if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return 'weixin';
    } else if (ua.match(/amap/i) == 'amap') {
      return 'amap';
    } else if (ua.match(/AlipayClient/i) == 'alipayclient') {
      return 'Alipay';
    } else if (ua.match(/dingtalk/i) == 'dingtalk') {
      return 'Ding';
    } else {
      return 'other';
    }
  },
  /**
   * 对比高德 App 的版本
   * @param {string} version - 传入的高德 App 版本
   * @returns {Promise<boolean>}
   */
  compareAppVersion(version = '080900') {
    return new Promise((resolve) => {
      native.compareDiv(version, (res) => {
        resolve(res);
      });
    });
  },
  /**
   * 获取 user id
   * @param {boolean} onlyGetId - 只获取用户 ID 不会打开登陆面板
   * @param {boolean} needRelogin - 强制重新登陆
   * @returns {Promise<any>}
   */
  getUserId(onlyGetId = false, needRelogin = false) {
    return new Promise((resolve, reject) => {
      native.getUserId(
        (data) => {
          const userId = data.userid;
          if (!userId) {
            reject(data);
          } else {
            resolve(userId);
          }
        },
        onlyGetId,
        needRelogin
      );
    });
  },
  //安卓900沉浸态
  isImmersion() {
    return new Promise((resolve) => {
      if (os.android) {
        native.compareDiv('090000', (res) => {
          if (res) {
            const obj = {
              action: 'getImmersiveStatusBarHeight',
            };
            bridge.send(obj, (info) => {
              console.log('沉浸态信息', info);
              if (info.height) {
                const height = info.height / window.devicePixelRatio;
                resolve(height);
              }
            });
          }
        });
      }
    });
  },
  checkServiceEnabledWithDialog() {
    return new Promise((resolve, reject) => {
      bridge.send({ action: 'checkServiceEnabledWithDialog' }, (info) => {});
    });
  },
  /**
   * 运力接口 source, miniApp, adcode
   * @param {*} params
   */
  transport(params) {
    return myLoader('get', CONFIG_AOS.transport, params);
  },
  getMapLocation() {
    return new Promise((resolve, reject) => {
      native.getMapLocation((res) => {
        resolve(res);
      });
    });
  },
  /**
   * 端链接转换
   */
  transformUrl(address) {
    const params = [
      {
        flag: 1,
        sign: 1,
      },
      {
        address,
        sign: 1,
      },
      {
        appfrom: 'operation',
      },
    ];
    return new Promise((resolve) => {
      loader.aosJsonp(
        CONFIG_AOS.transform,
        params,
        (res) => {
          console.log('短链接', res);
          if (+res.code === 1) {
            resolve(res);
          } else {
            resolve(address);
          }
        },
        false,
        false
      );
    });
  },
  /**
   * 首页主接口
   * @param tid
   * @param act
   * @returns {*}
   */

  index(source, driver_sharecode = '') {
    return myLoader('get', CONFIG_AOS.index, [
      {
        source,
        sign,
      },
      {
        driver_sharecode,
      },
    ]);
  },
  /**
   * token 带奖品的接口
   * @param token
   * @returns {*}
   */

  token(token) {
    return myLoader('get', CONFIG_AOS.token, [
      {
        token,
        sign,
      },
    ]);
  },
  /**
   * 获取手机验证码
   */
  verify(params) {
    return myLoader('get', CONFIG_AOS.verify, params);
  },
  /**
   * 领取奖券 端内无验证码 端外有验证码
   */
  reward(params, isInAmap) {
    const getNew = isInAmap ? CONFIG_AOS.get_new : CONFIG_AOS.get_new;
    return myLoader('get', getNew, params);
  },
  /**
   * 下载接口
   */
  download(source) {
    return myLoader('get', CONFIG_AOS.download, [{ source, sign }]);
  },
};
